import React from 'react'
import { SimpleTextarea } from './SimpleTextarea'
import { RichTextarea } from './RichTextarea'
import type { TextareaProps } from './types'

// Componente Textarea principal
export const Textarea: React.FC<TextareaProps> = (props) => {
  if (props.variant === 'rich') {
    return <RichTextarea {...props} />
  }
  
  return <SimpleTextarea {...props} />
}

// Re-export dos tipos para facilitar importação
export type { TextareaProps, SimpleTextareaProps, RichTextareaProps } from './types'

// Export para compatibilidade
export default Textarea